module.exports = __webpack_public_path__ + "5770f577ff92d5824ad7e17bc97920b4.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/power_has_a_price-420.webp.png
// module id = 512
// module chunks = 0